import { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import {
  Row,
  Col,
  Badge,
  Button,
  Form,
  Modal,
  Spinner,
  FormCheck,
} from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  useUpdatePlaylistProgramMutation,
  useDeletePlaylistProgramMutation,
  useInsertPlaylistProgramMutation,
  useUpdatePlaylistFromTemplateMutation,
  useGetDaysPlaylistQuery,
  useGetEPGDataQuery,
  useUpdateEpgMutation,
} from "../../slices/playlistsApiSlice.js";
import { useGetAllIdentsQuery } from "../../slices/identsApiSlice.js";
import { useGetAllProgramsQuery } from "../../slices/programsApiSlice.js";
// import { timeMinuteDefaults } from "../../util/timeMinuteDefaults.jsx";
import { useGetAllGraphicsValueLabelQuery } from "../../slices/graphicsApiSlice.js";
import ModalProgram from "./ModalProgram.jsx";
import ModalPlaylist from "./ModalPlaylist.jsx";
import PlaylistsProgramsButton from "./PlaylistsProgramsButton.jsx";
import PlaylistsLiveIdent from "./PlaylistsLiveIdent.jsx";
import PlaylistsName from "./PlaylistsName.jsx";
import PlaylistsSynopsis from "./PlaylistsSynopsis.jsx";
import PlaylistsStartTime from "./PlaylistsStartTime.jsx";
import PlaylistsFileIdent from "./PlaylistsFileIdent.jsx";
import PlaylistsIsLive from "./PlaylistsIsLive.jsx";
// import PlaylistsMediaRuntime from "./PlaylistsMediaRuntime.jsx";
import PlaylistsAddBreak from "./PlaylistsAddBreak.jsx";
import PlaylistsSlotRuntime from "./PlaylistsSlotRuntime.jsx";
import PlaylistsParentalGuidance from "./PlaylistsParentalGuidance.jsx";
import PlaylistsGenreSubgenre from "./PlaylistsGenreSubgenre.jsx";
import PlaylistsInProgramBreaks from "./PlaylistsInProgramBreaks.jsx";
import { toast } from "react-toastify";

const Playlists = () => {
  const startDate = new Date();
  startDate.setUTCHours(24, 0, 0, 0);

  const [selectedDate, setSelectedDate] = useState(startDate);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [isSpinner, setIsSpinner] = useState(false);
  const [programDetails, setProgramDetails] = useState({
    _id: "",
    txDateId: "",
    program: "",
    name: {
      name: "",
      isDirty: false,
    },
    synopsis: {
      synopsis: "",
      isDirty: false,
    },
    isLive: {
      isLive: false,
      isDirty: false,
    },
    isAvailable: {
      isAvailable: false,
      isDirty: false,
    },
    startTime: {
      startTime: null,
      isDirty: false,
    },
    slotRuntime: {
      slotRuntime: null,
      isDirty: false,
    },
    isLocked: {
      isLocked: false,
      isDirty: false,
    },
    parentalrating: {
      parentalrating: "",
      isDirty: false,
    },
    Genre: {
      Genre: "",
      isDirty: false,
    },
    Subgenre: {
      Subgenre: "",
      isDirty: false,
    },
    inProgramBreaks: {
      inProgramBreaks: 0,
      isDirty: false,
    },
    preRoll: {
      file: {
        ident: {
          ident: "",
          isDirty: false,
        },
        addBreak: {
          addBreak: 1,
          isDirty: false,
        },
        mediaRuntime: {
          mediaRuntime: 0,
          isDirty: false,
        },
        graphics: {
          graphics: "",
          isDirty: false,
        },
        media: {
          paidSongs: {
            paidSongs: false,
            isDirty: false,
          },
        },
      },
      live: {
        ident: {
          ident: "",
          isDirty: false,
        },
        addBreak: {
          addBreak: 1,
          isDirty: false,
        },
        mediaRuntime: {
          mediaRuntime: 0,
          isDirty: false,
        },
        graphics: {
          graphics: "",
          isDirty: false,
        },
        introIdent: {
          introIdent: "",
          isDirty: false,
        },
        media: {
          media: "",
          isDirty: false,
        },
      },
    },
  });

  const [newProgramDetails, setNewProgramDetails] = useState({
    _id: "",
    startHours: 0,
    startMinutes: 0,
  });

  const [formEdited, setFormEdited] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [showModalProgram, setShowModalProgram] = useState(false);
  const [showModalPlaylist, setShowModalPlaylist] = useState(false);
  const [showModalEPG, setShowModalEPG] = useState(false);
  const [showModalEPGUpdate, setShowModalEPGUpdate] = useState(false);
  const [reportEPGDays, setReportEPGDays] = useState(39);
  const [skipEPGData, setSkipEPGData] = useState(true);
  const [epgUpdateData, setEpgUpdateData] = useState(true);

  const {
    data: daysPrograms,
    error,
    isLoading,
  } = useGetDaysPlaylistQuery(selectedDate.getTime());

  const {
    data: allIdentsData,
    error: identsError,
    isLoading: identsLoading,
  } = useGetAllIdentsQuery();

  const {
    data: programsData,
    // error: programsError,
    // isLoading: programsLoading,
  } = useGetAllProgramsQuery();

  const { data: graphics } = useGetAllGraphicsValueLabelQuery();

  const [updatePlaylistProgram] = useUpdatePlaylistProgramMutation();
  const [deletePlaylistProgram] = useDeletePlaylistProgramMutation();
  const [insertPlaylistProgram] = useInsertPlaylistProgramMutation();
  const [updateEPG] = useUpdateEpgMutation();
  const [syncPlaylist] = useUpdatePlaylistFromTemplateMutation();

  
  const {
    data: EPGData,
    isLoading: EPGDataLoading,
    error: EPGDataError,
  } = useGetEPGDataQuery(reportEPGDays, {
    skip: skipEPGData,
  });

  // test useEffect
  useEffect(() => {
    console.log("programDetails", programDetails);
  }, [programDetails]);
  // test useEffect

  useEffect(() => {
    setSkipEPGData(false);
  }, [reportEPGDays]);

  useEffect(() => {
    if (startDate.getDay() === 1) {
      setReportEPGDays(28);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (programsData) {
      setNewProgramDetails({
        ...newProgramDetails,
        _id: programsData[0]._id,
      });
    }
    // eslint-disable-next-line
  }, [programsData]);

  useEffect(() => {
    if (error) {
      console.error("Error fetching playlist programs:", error);
    }
  }, [error]);

  useEffect(() => {
    if (daysPrograms && daysPrograms.length > 0) {
      if (!selectedProgram) {
        setSelectedProgram(daysPrograms[0].programs._id);
      }
      if (daysPrograms[0].isLocked) {
        setIsLocked(true);
      } else {
        setIsLocked(false);
      }
    }
    // eslint-disable-next-line
  }, [daysPrograms]);

  useEffect(() => {
    if (daysPrograms && selectedProgram) {
      const program = daysPrograms.find(
        (item) => item.programs._id === selectedProgram
      );
      if (program) {
        setProgramDetails({
          ...programDetails,
          _id: program.programs._id,
          txDateId: program.programs.txDateId,
          program: program.programs.program,
          name: {
            name: program.programs.name?.name || "",
            isDirty: program.programs.name?.isDirty || false,
          },
          synopsis: {
            synopsis: program.programs.synopsis?.synopsis || "",
            isDirty: program.programs.synopsis?.isDirty || false,
          },
          isLive: {
            isLive: program.programs.isLive?.isLive || false,
            isDirty: program.programs.isLive?.isDirty || false,
          },
          isAvailable: {
            isAvailable: program.programs.isAvailable?.isAvailable || false,
            isDirty: program.programs.isAvailable?.isDirty || false,
          },
          startTime: {
            startTimeHours: Math.floor(
              program.programs.startTime?.startTime / 60
            ),
            startTimeMinutes: program.programs.startTime?.startTime % 60,
            startTime: program.programs.startTime?.startTime || 0,
            isDirty: program.programs.startTime?.isDirty || false,
          },
          slotRuntime: {
            slotRuntimeHours: Math.floor(
              program.programs.slotRuntime?.slotRuntime / 60
            ),
            slotRuntimeMinutes: program.programs.slotRuntime?.slotRuntime % 60,
            slotRuntime: program.programs.slotRuntime?.slotRuntime || 0,
            isDirty: program.programs.slotRuntime?.isDirty || false,
          },
          isLocked: {
            isLocked: program.programs.isLocked?.isLocked || false,
            isDirty: program.programs.isLocked?.isDirty || false,
          },
          parentalrating: {
            parentalrating:
              program.programs.parentalrating?.parentalrating || "",
            isDirty: program.programs.parentalrating?.isDirty || false,
          },
          Genre: {
            Genre: program.programs.Genre?.Genre || "",
            isDirty: program.programs.Genre?.isDirty || false,
          },
          Subgenre: {
            Subgenre: program.programs.Subgenre?.Subgenre || "",
            isDirty: program.programs.Subgenre?.isDirty || false,
          },
          inProgramBreaks: {
            inProgramBreaks:
              program.programs.inProgramBreaks?.inProgramBreaks || 0,
            isDirty: program.programs.inProgramBreaks?.isDirty || false,
          },
          preRoll: {
            file: {
              ident: {
                ident: program.programs.preRoll?.file?.ident?.ident || "",
                isDirty:
                  program.programs.preRoll?.file?.ident?.isDirty || false,
              },
              addBreak: {
                addBreak:
                  program.programs.preRoll?.file?.addBreak?.addBreak || 1,
                isDirty:
                  program.programs.preRoll?.file?.addBreak?.isDirty || false,
              },
              mediaRuntime: {
                mediaRuntime:
                  program.programs.preRoll?.file?.mediaRuntime?.mediaRuntime ||
                  0,
                isDirty:
                  program.programs.preRoll?.file?.mediaRuntime?.isDirty ||
                  false,
              },
              graphics: {
                graphics:
                  program.programs.preRoll?.file?.graphics?.graphics || "",
                isDirty:
                  program.programs.preRoll?.file?.graphics?.isDirty || false,
              },
              media: {
                paidSongs: {
                  paidSongs:
                    program.programs.preRoll?.file?.media?.paidSongs
                      ?.paidSongs || false,
                  isDirty:
                    program.programs.preRoll?.file?.media?.paidSongs?.isDirty ||
                    false,
                },
              },
            },
            live: {
              ident: {
                ident: program.programs.preRoll?.live?.ident?.ident || "",
                isDirty:
                  program.programs.preRoll?.live?.ident?.isDirty || false,
              },
              addBreak: {
                addBreak:
                  program.programs.preRoll?.live?.addBreak?.addBreak || 1,
                isDirty:
                  program.programs.preRoll?.live?.addBreak?.isDirty || false,
              },
              mediaRuntime: {
                mediaRuntime:
                  program.programs.preRoll?.live?.mediaRuntime?.mediaRuntime ||
                  0,
                isDirty:
                  program.programs.preRoll?.live?.mediaRuntime?.isDirty ||
                  false,
              },
              graphics: {
                graphics:
                  program.programs.preRoll?.live?.graphics?.graphics || "",
                isDirty:
                  program.programs.preRoll?.live?.graphics?.isDirty || false,
              },
              introIdent: {
                introIdent:
                  program.programs.preRoll?.live?.introIdent?.introIdent || "",
                isDirty:
                  program.programs.preRoll?.live?.introIdent?.isDirty || false,
              },
              media: {
                media: program.programs.preRoll?.live?.media?.media || "",
                isDirty:
                  program.programs.preRoll?.live?.media?.isDirty || false,
              },
            },
          },
        });
      }
    }
    // eslint-disable-next-line
  }, [daysPrograms, selectedProgram]);

  useEffect(() => {
    const totalMinutes =
      programDetails.startTime.startTimeHours * 60 +
      programDetails.startTime.startTimeMinutes;
    setProgramDetails({
      ...programDetails,
      startTime: {
        startTime: totalMinutes,
        isDirty: true,
      },
    });
    // eslint-disable-next-line
  }, [programDetails.startTimeHours, programDetails.startTimeMinutes]);

  useEffect(() => {
    const totalMinutes =
      programDetails.slotRuntime.slotRuntimeHours * 60 +
      programDetails.slotRuntime.slotRuntimeMinutes;
    setProgramDetails({
      ...programDetails,
      slotRuntime: {
        slotRuntime: totalMinutes,
        isDirty: true,
      },
    });
    // eslint-disable-next-line
  }, [programDetails.slotRuntimeHours, programDetails.slotRuntimeMinutes]);

  const convertMinutesToTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes}`;
  };

  const formatRuntime = (totalMinutes) => {
    if (totalMinutes === 0) {
      return "Midnight";
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let formattedTime = "";

    if (hours > 0) {
      formattedTime += `${hours} h`;
    }

    if (minutes > 0) {
      if (formattedTime !== "") {
        formattedTime += " ";
      }
      formattedTime += `${minutes} m`;
    }

    return formattedTime;
  };

  function pad(n) {
    return n < 10 ? "0" + n : n;
  }
  const handleDateChange = (date) => {
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const ISODate = year + "-" + month + "-" + day;
    const newDate = new Date(ISODate);

    setSelectedDate(newDate);
    setSelectedProgram(null);
  };

  const handleProgramClick = (programId) => {
    setSelectedProgram(programId);
    setFormEdited(false);
  };

  const handleDelete = async () => {
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this playlist program?"
      );
      if (confirmed) {
        await deletePlaylistProgram(programDetails._id);
        setSelectedProgram(null);
      }
    } catch (error) {
      console.error("Error deleting playlist program:", error);
    }
  };

  const handleNewProgramSave = async (e) => {
    e.preventDefault();

    try {
      const newSelectedProgram = programsData.find(
        (p) => p._id === newProgramDetails._id
      );

      if (newSelectedProgram) {
        const newProgramData = {
          txDateId: programDetails.txDateId,
          program: newSelectedProgram._id,
          name: { name: newSelectedProgram.name, isDirty: false },
          synopsis: {
            synopsis: newSelectedProgram.synopsis,
            isDirty: false,
          },
          isLive: { isLive: false, isDirty: false },
          isAvailable: { isAvailable: false, isDirty: false },
          parentalrating: {
            parentalrating: newSelectedProgram.parentalrating,
            isDirty: false,
          },
          Genre: { Genre: newSelectedProgram.Genre, isDirty: false },
          Subgenre: { Subgenre: newSelectedProgram.Subgenre, isDirty: false },
          inProgramBreaks: {
            inProgramBreaks: newSelectedProgram.inProgramBreaks,
            isDirty: false,
          },
          startTime: {
            startTimeHours: newProgramDetails.startHours, // to check
            startTimeMinutes: newProgramDetails.startMinutes, // to check
            startTime:
              newProgramDetails.startHours * 60 +
              newProgramDetails.startMinutes, // to check
            isDirty: false,
          },
          slotRuntime: {
            slotRuntimeHours: Math.floor(newSelectedProgram.slotRuntime / 60),
            slotRuntimeMinutes: newSelectedProgram.slotRuntime % 60,
            slotRuntime: newSelectedProgram.slotRuntime,
            isDirty: false,
          },
          isLocked: { isLocked: false, isDirty: false },
          preRoll: {
            file: {
              ident: { ident: newSelectedProgram.preRoll.file.ident },
              addBreak: {
                addBreak: newSelectedProgram.preRoll.file.addBreak,
                isDirty: false,
              },
              mediaRuntime: {
                mediaRuntime:
                  newSelectedProgram?.preRoll?.file?.mediaRuntime || 0,
                isDirty: false,
              },
              graphics: { graphics: newSelectedProgram.preRoll.file.graphics },
              media: {
                paidSongs: {
                  paidSongs:
                    newSelectedProgram?.preRoll?.file?.media?.paidSongs
                      ?.paidSongs || false,
                  isDirty: false,
                },
              },
            },
            live: {
              ident: { ident: newSelectedProgram.preRoll.live.ident },
              addBreak: {
                addBreak: newSelectedProgram.preRoll.live.addBreak,
                isDirty: false,
              },
              mediaRuntime: {
                mediaRuntime:
                  newSelectedProgram?.preRoll?.live?.mediaRuntime || 0,
                isDirty: false,
              },
              graphics: { graphics: newSelectedProgram.preRoll.live.graphics },
              introIdent: {
                introIdent: newSelectedProgram.preRoll.live.introIdent,
              },
              media: { media: newSelectedProgram.preRoll.live.media },
            },
          },
        };

        const insertedPlaylistProgram = await insertPlaylistProgram(
          newProgramData
        );

        setSelectedProgram(insertedPlaylistProgram.data._id);
        setNewProgramDetails({
          _id: "",
          startHours: 0,
          startMinutes: 0,
        });
        setShowModalProgram(false);
      }
    } catch (error) {
      console.error("Error deleting playlist program:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("programDetails:", programDetails);
      const updatedProgram = await updatePlaylistProgram(programDetails);
      setFormEdited(false);
      console.log("updatedProgram:", updatedProgram);
      setSelectedProgram(updatedProgram.data.newProgram._id); // Assuming updatedProgram has _id property
    } catch (error) {
      console.error("Error updating playlist program:", error);
    }
  };

  const handlePlaylistSync = async () => {
    setIsSpinner(true);
    const numberOfDays = new Date().getDay() === 1 ? 45 : 8;
    const syncedPlaylist = await syncPlaylist(numberOfDays);
    console.log("syncedPlaylist", syncedPlaylist);
    setIsSpinner(false);
  };

  const handleEPGButtonClick = async () => {
    if (EPGDataLoading) {
      toast.info("Loading EPG data...");
      return;
    }

    if (EPGDataError) {
      toast.error("Error loading EPG data");
      return;
    }

    if (!EPGData || EPGData.length === 0) {
      toast.error("No EPG data available");
      return;
    }
    let completeSchedule = true;
    let errorDate = "";
    // console.log("EPGData", EPGData);
    for (const epg of EPGData) {
      if (epg.completeSchedule === false) {
        errorDate = epg.txDate;
        completeSchedule = false;
      }
    }

    if (!completeSchedule) {
      setShowModalEPG(false);
      const Msg = () => (
        <div>
          <p>Correct Schedule!!! </p>
          <p>
            There is an error in the schedule for {formatDate(errorDate)} please
            correct
          </p>
        </div>
      );

      const formatDate = (date) => {
        const formattedDate = new Date(date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
        });
        return formattedDate;
      };

      toast.error(Msg, {
        position: "top-center",
        autoClose: 20000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    for (const epg of EPGData) {
      // epgIds.push(epg._id, epg.txDate);
      let fileData = "";
      if (epg.line1) fileData += epg.line1;
      epg.programs.forEach((program) => {
        if (program.line10) fileData += program.line10;
        if (program.line20) fileData += program.line20;
        if (program.line21) fileData += program.line21;
        if (program.line22) fileData += program.line22;
        if (program.line30) fileData += program.line30;
      });
      if (epg.line99) fileData += epg.line99;
      const file = new Blob([fileData], {
        type: "text/plain;charset=utf-8",
      });

      let fileName = epg.fileName;
      if (process.env.REACT_APP_ENV === "development") {
        fileName = "dev-" + fileName;
      } else if (process.env.REACT_APP_ENV === "staging") {
        fileName = "stage-" + fileName;
      }
      await saveAs(file, fileName);

      await new Promise((resolve) => setTimeout(resolve, 1000)); // 1000 milliseconds delay
    }
    completeSchedule = true;
    setShowModalEPG(false);
    setShowModalEPGUpdate(true);
    setEpgUpdateData(EPGData);
  };

  const handleEpgUpdate = async () => {
    setShowModalEPGUpdate(false);

    epgUpdateData.map(async (eachEPG) => {
      await updateEPG(eachEPG);
    });
  };

  const formatDate = (date) => {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    const dayNumber = date.getDate();
    let suffix = "";
    if (dayNumber === 1 || dayNumber === 21 || dayNumber === 31) {
      suffix = "st";
    } else if (dayNumber === 2 || dayNumber === 22) {
      suffix = "nd";
    } else if (dayNumber === 3 || dayNumber === 23) {
      suffix = "rd";
    } else {
      suffix = "th";
    }
    return formattedDate.replace(/\b(\d{1,2})\b/, `$1${suffix}`);
  };

  return (
    <div>
      <Row>
        <Col>
          <Calendar
            onChange={handleDateChange}
            value={selectedDate}
            className="shadow-lg"
            minDate={new Date("2024-07-11")}
            maxDate={new Date(Date.now() + 36288e5)}
          />
        </Col>
      </Row>
      <Row className="h2 d-inline">
        <Badge
          bg={isLocked ? "danger" : "success"}
          className="my-3 me-2 col-9 "
        >
          {formatDate(selectedDate)}
        </Badge>
        <Button
          variant="primary"
          className="my-3 me-1 col-1 shadow-lg "
          onClick={handlePlaylistSync}
        >
          Sync
          {isSpinner && (
            <Spinner
              className="ms-2 "
              animation="border"
              size="sm"
            />
          )}
        </Button>
        <Button
          variant="primary"
          className="my-3 me-1 col-1 shadow-lg "
          onClick={() => {
            setShowModalPlaylist(true);
          }}
        >
          Playlist
        </Button>
        <Button
          variant="primary"
          className="my-3 col-1 shadow-lg "
          onClick={() => {
            setShowModalEPG(true);
          }}
        >
          EPG
        </Button>
      </Row>
      <Row>
        {PlaylistsProgramsButton(
          isLoading,
          error,
          daysPrograms,
          handleProgramClick,
          selectedProgram,
          convertMinutesToTime,
          formatRuntime
        )}
        <Col className="border border-1 ">
          {daysPrograms && (
            <Form onSubmit={handleSubmit}>
              <Row className="text-center h4 m-2 ">
                <Col>Program Details</Col>
              </Row>
              <small>
                {programDetails.name &&
                  PlaylistsName(
                    programDetails,
                    setProgramDetails,
                    setFormEdited,
                    isLocked
                  )}
                {PlaylistsSynopsis(
                  programDetails,
                  setProgramDetails,
                  setFormEdited,
                  isLocked
                )}
                {PlaylistsStartTime(
                  programDetails,
                  setProgramDetails,
                  setFormEdited,
                  isLocked
                )}
                {PlaylistsSlotRuntime(
                  programDetails,
                  setProgramDetails,
                  setFormEdited,
                  isLocked
                )}
                <PlaylistsParentalGuidance
                  programDetails={programDetails}
                  setProgramDetails={setProgramDetails}
                  setFormEdited={setFormEdited}
                  isLocked={isLocked}
                />
                <PlaylistsGenreSubgenre
                  programDetails={programDetails}
                  setProgramDetails={setProgramDetails}
                  setFormEdited={setFormEdited}
                  isLocked={isLocked}
                />
                {/* PlaylistsInProgramBreaks */}
                {/* {PlaylistsParentalGuidance(
                  programDetails,
                  setProgramDetails,
                  setFormEdited
                )} */}
                {PlaylistsIsLive(
                  programDetails,
                  setProgramDetails,
                  setFormEdited,
                  isLocked
                )}
                {!programDetails.isLive.isLive && (
                  <>
                    {PlaylistsFileIdent(
                      programDetails,
                      setProgramDetails,
                      setFormEdited,
                      identsLoading,
                      identsError,
                      allIdentsData,
                      graphics,
                      isLocked
                    )}
                    {PlaylistsAddBreak(
                      programDetails,
                      setProgramDetails,
                      setFormEdited,
                      "file",
                      isLocked
                    )}
                    <PlaylistsInProgramBreaks
                      programDetails={programDetails}
                      setProgramDetails={setProgramDetails}
                      setFormEdited={setFormEdited}
                      isLocked={isLocked}
                    />
                    <Row className="align-items-center pt-2 ">
                      <Col xs={2}>Paid Songs:</Col>
                      <Col sm="1">
                        <FormCheck
                          type="checkbox"
                          isValid
                          checked={
                            programDetails.preRoll.file.media.paidSongs
                              .paidSongs
                              ? true
                              : false
                          }
                          id="paidSongs"
                          onChange={(e) => {
                            setProgramDetails({
                              ...programDetails,
                              preRoll: {
                                ...programDetails.preRoll,
                                file: {
                                  ...programDetails.preRoll.file,
                                  media: {
                                    ...programDetails.preRoll.file.media,
                                    paidSongs: {
                                      ...programDetails.preRoll.file.media
                                        .paidSongs,
                                      paidSongs: e.target.checked,
                                    },
                                    isDirty: e.target.checked,
                                  },
                                },
                              },
                            });
                            setFormEdited(true);
                          }}
                          disabled={isLocked}
                        />
                      </Col>
                    </Row>
                  </>
                )}
                {programDetails.isLive.isLive && (
                  <>
                    {PlaylistsLiveIdent(
                      programDetails,
                      setProgramDetails,
                      setFormEdited,
                      identsLoading,
                      identsError,
                      allIdentsData,
                      graphics,
                      isLocked
                    )}
                    {PlaylistsAddBreak(
                      programDetails,
                      setProgramDetails,
                      setFormEdited,
                      "live",
                      isLocked
                    )}
                  </>
                )}
              </small>
              {!isLocked && (
                <Row className="align-items-center pt-4 text-center">
                  <Col>
                    <Button
                      variant="danger"
                      className="ms-2"
                      onClick={handleDelete}
                      disabled={formEdited}
                    >
                      Delete
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      variant="primary"
                      onClick={() => {
                        setShowModalProgram(true);
                      }}
                      disabled={formEdited}
                    >
                      Add Program
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={!formEdited}
                    >
                      Save Changes
                    </Button>
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </Col>
      </Row>
      <Modal
        show={showModalProgram}
        onHide={() => {
          setShowModalProgram(false);
          setNewProgramDetails({
            _id: programsData ? programsData[0]._id : "",
            startHours: 0,
            startMinutes: 0,
          });
        }}
      >
        <ModalProgram
          // hours={hours}
          // minutes={minutes}
          setNewProgramDetails={setNewProgramDetails}
          newProgramDetails={newProgramDetails}
          programsData={programsData}
          setShowModalProgram={setShowModalProgram}
          handleNewProgramSave={handleNewProgramSave}
        />
      </Modal>
      <Modal
        show={showModalPlaylist}
        size="xl"
        onHide={() => {
          setShowModalPlaylist(false);
        }}
        scrollable
      >
        <ModalPlaylist
          daysPrograms={daysPrograms}
          setShowModalPlaylist={setShowModalPlaylist}
          graphics={graphics}
          isLocked={isLocked}
        />
      </Modal>
      <Modal
        show={showModalEPG}
        onHide={() => {
          setShowModalEPG(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>How Many Days</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Select
            value={reportEPGDays}
            xs="1"
            size="sm"
            id="epgInput"
            onChange={(e) => {
              setReportEPGDays(Number(e.target.value));
            }}
          >
            {Array.from({ length: 40 }, (_, i) => (
              <option
                key={i + 1}
                value={i + 1}
              >
                {i + 1} {i === 0 ? "Day" : "Days"}
              </option>
            ))}
          </Form.Select>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalEPG(false);
            }}
          >
            Close
          </Button>
          <Button
            id="epgButtonClick"
            variant="danger"
            onClick={handleEPGButtonClick}
          >
            Produce EPG FIles
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModalEPGUpdate}
        onHide={() => {
          setShowModalEPGUpdate(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update EPG Versions</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalEPGUpdate(false);
            }}
          >
            No
          </Button>
          <Button
            id="epgUpdate"
            variant="danger"
            onClick={handleEpgUpdate}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Playlists;
